import React from "react";
import PropTypes from "prop-types";

var CloseIcon = function CloseIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#737373" : _ref$color;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    "aria-hidden": "true",
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1C6.46875 1 4.1875 2.34375 2.9375 4.5C1.65625 6.6875 1.65625 9.34375 2.9375 11.5C4.1875 13.6875 6.46875 15 9 15C11.5 15 13.7812 13.6875 15.0312 11.5C16.3125 9.34375 16.3125 6.6875 15.0312 4.5C13.7812 2.34375 11.5 1 9 1ZM9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM6.625 5.65625C6.8125 5.46875 7.15625 5.46875 7.34375 5.65625L9 7.3125L10.625 5.65625C10.8125 5.46875 11.1562 5.46875 11.3438 5.65625C11.5312 5.84375 11.5312 6.1875 11.3438 6.375L9.6875 8L11.3438 9.65625C11.5312 9.84375 11.5312 10.1875 11.3438 10.375C11.1562 10.5625 10.8125 10.5625 10.625 10.375L9 8.71875L7.34375 10.375C7.15625 10.5625 6.8125 10.5625 6.625 10.375C6.4375 10.1875 6.4375 9.84375 6.625 9.65625L8.28125 8L6.625 6.375C6.4375 6.1875 6.4375 5.84375 6.625 5.65625Z",
    fill: color
  }));
};

CloseIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string
};
CloseIcon.defaultProps = {
  width: 18,
  height: 16
};
export default CloseIcon;